import script from "./TempJ.vue?vue&type=script&lang=ts&setup=true"
export * from "./TempJ.vue?vue&type=script&lang=ts&setup=true"

import "./TempJ.vue?vue&type=style&index=0&id=2719b0ec&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2719b0ec"]])

export default __exports__